module.exports = __webpack_public_path__ + "img/blog-4.bc403019.jpg";